import { computed, observable } from 'mobx';
import moment from "moment/moment";
import {action} from "mobx/lib/mobx";
import BaseStore from "./BaseStore";
import QCCheckModel from "../models/QCCheckModel";

export default class QCCheckStore extends BaseStore{

  dailyOptions = [
    {label: 'Day', value: '*'},
    {label: 'Sunday', value: '0'},
    {label: 'Monday', value: '1'},
    {label: 'Tuesday', value: '2'},
    {label: 'Wednesday', value: '3'},
    {label: 'Thursday', value: '4'},
    {label: 'Friday', value: '5'},
    {label: 'Saturday', value: '6'},
  ];

  @observable filters = {
    series_id: null,
    qc_type: null,
    date_from: moment().add(-6, 'days').format('YYYY-MM-DDT00:00:00'),
    date_to: moment().format('YYYY-MM-DDT00:00:00'),
  };

  constructor(transportLayer){
    super(QCCheckModel, transportLayer)
  }

  @action onChangeSeries = (e) => this.filters.series_id = e.target.value;
  @action onChangeQcType = (e) => this.filters.qc_type = e.target.value;
  @action onChangeDateFrom = (e) => this.filters.date_from = e.target.value;
  @action onChangeDateTo = (e) => this.filters.date_to = e.target.value;

  @action resetFilters(){
    this.filters = {
      series_id: null,
      qc_type: null,
      date_from: moment().add(-6, 'days').format('YYYY-MM-DDT00:00:00'),
      date_to: moment().format('YYYY-MM-DDT00:00:00'),
    }
  }

  startManualQC(filters){
    this.loading = true;
    return this.transportLayer.runManualQC(filters);
  }

  isAsterisk = arr => arr.reduce((acc, item) => (acc && item === '*'), true);
  isNumber = arr => arr.reduce((acc, item) => (acc && (!!+item || +item === 0)), true);

  interpretCronFormat = (cronFormat) => {
    cronFormat = cronFormat.split(' ');
    let minute = cronFormat[0],
      hour = cronFormat[1],
      day = cronFormat[2],
      month = cronFormat[3],
      weekDay = cronFormat[4];

    if (minute.indexOf('/') > -1 && this.isAsterisk([hour, day, month, weekDay])) {
      return `Every ${minute.split('/')[1]} minute(s)`;
    } else if (this.isNumber([minute]) && !this.isNumber([hour]) && hour.indexOf('*') > -1 && this.isAsterisk([day, month, weekDay])) {
      return `Every ${hour.split('/')[1]} hour(s)` + (!!+minute ? ` at ${minute} minute(s)` : '');
    } else if (this.isNumber([minute, hour]) && this.isAsterisk([day, month]) && (this.isAsterisk([weekDay]) || this.isNumber([weekDay]))) {
      return `Every ${this.dailyOptions.find(item => item.value === weekDay).label} at ${moment().hours(hour).minutes(minute).format('HH:mm')}`
    }
  }

  fetchStationQcRules(station_id){
    return this.transportLayer.fetchStationQcRules(station_id);
  }

  fetchCheckLogs(filters){
    return this.transportLayer.fetchCheckLogs(filters);
  }
}


// WEBPACK FOOTER //
// ./src/stores/QCCheckStore.js